import { memo } from 'react';
import { Stack, Text, VStack } from '@chakra-ui/react';

import InterText from 'shared/InterText';

const StageCardComponent = ({ cardIndex, amountOfCards, title, text, ...props }) => (
  <Stack
    direction={{ mobile: 'column', xt: 'row', xxxl: 'column' }}
    w="full"
    minW={{ xt: '350px', xxxl: '410px' }}
    h="full"
    minH={{ mobile: '175px', xt: '134px', xxxl: '263px' }}
    gap={{ mobile: '18px', xxxl: '20px' }}
    p={{ mobile: '18px 19px', xxxl: '32px' }}
    borderRadius={{ mobile: '24px', xxxl: '32px' }}
    align="start"
    justify="space-between"
    bgColor="ourWhite"
    color="deepBlue"
    {...props}
  >
    <Text textStyle="b1" fontSize={{ mobile: '18px', xt: '20px', xxxl: '30px' }}>
      {cardIndex}/{amountOfCards}
    </Text>

    <VStack w="full" align="start" gap={{ mobile: '4px', xxxl: '12px' }}>
      <Text as="h3" textStyle="b1" fontSize={{ mobile: '18px', xt: '20px', xxxl: '30px' }}>
        {title}
      </Text>

      <InterText textStyle="b3" fontSize={{ mobile: '16px', xxxl: '18px' }}>
        {text}
      </InterText>
    </VStack>
  </Stack>
);

export default memo(StageCardComponent);
